import React, { useState } from 'react';
import './ArticleCard.css';

function ArticleCard({ article, onDelete }) {
  const [expanded, setExpanded] = useState(false);

  const handleDelete = () => {
    onDelete(article._id);
  };

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  // Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  return (
    <div className="article-card">
      <div className="article-header">
        <h3 className="article-title">{article.title}</h3>
        <button className="delete-btn" onClick={handleDelete} title="Delete article">
          🗑️
        </button>
      </div>
      
      <div className="article-meta">
        <span className="author">👤 {article.author}</span>
        {/* <span className="date">📅 {formatDate(article.createdAt)}</span> */}
        <span className="date">📅 {formatDate(article.updatedAt)}</span>
      </div>
      
      <div className={`article-content ${expanded ? 'expanded' : 'collapsed'}`}>
        <p>{article.content}</p>
      </div>
              <button className="read-more-btn" onClick={toggleExpanded}>
          {expanded ? 'Show Less ▲' : 'Read More ▼'}
        </button>
      {/* {article.content.length > 200 && (
        <button className="read-more-btn" onClick={toggleExpanded}>
          {expanded ? 'Show Less ▲' : 'Read More ▼'}
        </button>
      )} */}
    </div>
  );
}

export default ArticleCard;
